export const NO_PROMPT = 'noPrompt';
export const TRUTHY_VALUE = 'true';
export const SECONDARY_DOC_COOKIE = 'secondary_doc';
